import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import WPAccordion from "../../../packages/WPAccordion";
import WPButton from "../../../packages/WPButton";
import { navigateToCreateNewPlant } from "../../../utils/Utils";
import ExportWarningIcon from "../../../packages/SVGs/ExportWarningIcon";
import ExportErrorIcon from "../../../packages/SVGs/ExportErrorIcon";
import "./DataWarnings.scss";

const DataWarnings = ({
  gapWarning,
  overlapWarning,
  summaryData,
  selectedTrain,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const createDataSummary = () => {
    const dataObj = {
      "New Rows": summaryData?.new_data_range.total_records ?? 0,
      Train: `Train ${selectedTrain}`,
      "Date Range": `${summaryData?.new_data_range.start} to ${summaryData?.new_data_range.end}`,
      Settings: t("dataWarnings.noChangesText"),
    };

    return Object.entries(dataObj);
  };

  const getHeaderForType = (type, title) => {
    return (
      <div>
        <span className={"header-icon"}>
          {type ? (
            type === "warning" ? (
              <ExportWarningIcon />
            ) : (
              <ExportErrorIcon />
            )
          ) : undefined}
        </span>
        {title}
      </div>
    );
  };

  return (
    <div>
      {gapWarning !== undefined && (
        <>
          <WPAccordion
            title={getHeaderForType("warning", t("dataWarnings.gapTitle"))}
            type="warning"
          >
            {gapWarning.message}
          </WPAccordion>
          <div>
            <div className="gap-warning-text">{t("dataWarnings.gapNote")}</div>
            <WPButton
              variant="text"
              size="small"
              customClass="create-new-plant-button"
              onClick={() => navigateToCreateNewPlant(navigate)}
            >
              {t("dataAppend.createNewPlant")}
            </WPButton>
          </div>
        </>
      )}

      {overlapWarning !== undefined && (
        <WPAccordion
          title={getHeaderForType("error", t("dataWarnings.conflictTitle"))}
          type="error"
          sideInfo={`${overlapWarning.overlap_count} ${t(
            "dataWarnings.overlappingTimestamps"
          )}`}
        >
          {overlapWarning.message}
          <ul>
            {overlapWarning.overlap_dates.map((date) => (
              <li key={date}>{date}</li>
            ))}
            {overlapWarning.overlap_count > 5 && (
              <li className="more-dates">
                + {overlapWarning.overlap_count - 5} {t("ValueStrings.more")}
              </li>
            )}
          </ul>
        </WPAccordion>
      )}

      <hr />

      <div className="summary-card">
        {createDataSummary().map((data) => (
          <div key={data[0]} className="summary-item">
            <strong>{data[0]}:</strong> {data[1]}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DataWarnings;
